import DataTableV2PaginatedMobile from '@/agilis/mobile/DataTableV2PaginatedMobile/DataTableV2PaginatedMobile.vue'
import Contact2Table from '@/applications/sales/components/Contact2Table/Contact2Table'

export default {
  name: 'Contact2TableMobile',
  mixins: [Contact2Table],
  components: {
    DataTableV2PaginatedMobile
  }
}
